export default function AboutSection() {
  return (
    <section id="about" className="relative py-16 md:py-20 bg-background-950">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary-500/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
              <i className="ri-information-line text-primary-400 text-xs"></i>
              <span className="text-primary-300 text-xs font-medium">关于我们</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
              6080新视觉影视
            </h2>
            <p className="mt-1 text-sm text-primary-400/70 font-medium">
              您的专属高清追剧平台
            </p>
            <div className="mt-5 space-y-3 text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl">
              <p>
                6080新视觉影视成立于对高清影视内容的热爱与追求，致力于为广大剧迷提供最优质的在线观剧体验。平台汇聚了海量热门电视剧资源，涵盖国产剧、韩剧、美剧、日剧、泰剧等多种类型，无论您喜欢古装玄幻、都市爱情还是悬疑推理，都能在这里找到心仪的作品。
              </p>
              <p>
                我们坚持免费、高清、无广告的核心原则，采用先进的视频编码技术，确保每一帧画面都清晰流畅。每日同步更新最新剧集，让您不错过任何精彩剧情。从经典老剧到当季热播，6080新视觉影视始终是您追剧路上的最佳伙伴。
              </p>
            </div>
            <div className="mt-6 flex flex-wrap gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                <span>免费观看</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                <span>1080P高清</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                <span>每日更新</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-checkbox-circle-line text-accent-400"></i>
                <span>全平台支持</span>
              </div>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[440px]">
            <div className="relative rounded-2xl overflow-hidden border border-background-700/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20home%20theater%20setup%20with%20large%20screen%20displaying%20dramatic%20scene%2C%20warm%20ambient%20lighting%20with%20amber%20and%20golden%20glow%2C%20cozy%20living%20room%20atmosphere%2C%20streaming%20entertainment%20concept%2C%20premium%20viewing%20experience%2C%20dark%20elegant%20interior&width=880&height=660&seq=about-6080&orientation=landscape"
                alt="6080新视觉影视 高清追剧体验"
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}